import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { coachFormAction, photoFileAction } from "../../redux/rootReducer";
import { updateCoachSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";
import user_image from '../../assets/i/user.svg';
import TextareaAutosize from "react-textarea-autosize";
import { COACH_FORM_INITIAL } from "../../redux/initialStateConstant";

// Ссылки на логотипы соцсетей
const vk = 'https://alga.by/fitness_images/social_networks_logos/vk.png';
const instagram = 'https://alga.by/fitness_images/social_networks_logos/instagram.png';
const youtube = 'https://alga.by/fitness_images/social_networks_logos/youtube.png';

const CoachForm = () => {
    const dispatch = useDispatch();
    const coach_form = useSelector(state => state.coach_form);
    const photo_file = useSelector(state => state.photo_file);
    const establishmentList = useSelector(state => state.establishmentList);

    const readFile = input => {
        // Ссылка на читаемый файл
        let file = input.target.files[0];

        // Создаём ссылку на FileReader
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            dispatch(photoFileAction({ file, image: reader.result }));
        };
    };

    // Сохранение ссылки на логотип соц. сети
    const choiceSocialNetworkLogo = (network, index) => {
        // Копируем массив с сылками
        let links_copy = coach_form.links.map(elem => {
            return { ...elem };
        });
        // Меняем значение в текущей ссылке
        links_copy[index].ico = network;

        // Сохраняем новое значение
        dispatch(coachFormAction({
            ...coach_form,
            links: links_copy
        }));

        setSocialNetworkIcoIndex(null);
    };

    // Индекс открытого дропдауна с выбором значка социальной сети
    const [socialNetworkIcoIndex, setSocialNetworkIcoIndex] = useState(null);

    if (!coach_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => {
                                dispatch(coachFormAction(COACH_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">Форма тренера</div>
                    </div>
                    <div className="form__field">
                        <label className="form__image-wrapper">
                            <input type="file" className="form__file" onChange={ file => readFile(file) } />
                            <div className="form__image"
                                 style={
                                     photo_file?.image
                                         ? { backgroundImage: `url(${ photo_file.image })`}
                                         : coach_form.image
                                         ? { backgroundImage: `url(${ site + coach_form.image })` }
                                         : { backgroundImage: `url(${ user_image })`, backgroundSize: `${ 38 }px`, opacity: .48 }
                                 }
                            />
                        </label>
                        {
                            (photo_file?.image) || coach_form.image
                                ? <div className="form__image-remove"
                                       onClick={ () => {
                                           dispatch(coachFormAction({
                                               ...coach_form,
                                               image: ''
                                           }));
                                           dispatch(photoFileAction(null));
                                       } } >Удалить</div>
                                : false
                        }
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Имя тренера</div>
                        <input type="text" className="input"
                            value={ coach_form.name }
                           onInput={ event => dispatch(coachFormAction({
                               ...coach_form,
                               name: event.target.value
                           })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Телефон</div>
                        <input type="phone" className="input" value={ coach_form.phone } onInput={ event => {
                            dispatch(coachFormAction({
                                ...coach_form,
                                phone: event.target.value
                            }));
                        } }/>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Почта</div>
                        <input type="phone" className="input" value={ coach_form.email } onInput={ event => {
                            dispatch(coachFormAction({
                                ...coach_form,
                                email: event.target.value
                            }));
                        } }/>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Описание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ coach_form.description }
                            onInput={ event => dispatch(coachFormAction({
                                ...coach_form,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper"
                             style={{ marginBottom: 12 }}
                             onClick={ () => {
                                 dispatch(coachFormAction({
                                     ...coach_form,
                                     hide: coach_form.hide === '0' ? '1' : '0'
                                 }));
                             } }
                        >
                            <div className={ `checkbox ${ coach_form.hide === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Скрыть в приложении</div>
                        </div>
                    </div>


                    <div className="form__field">
                        <div className="input__caption">Ссылки</div>
                        {
                            coach_form.links.length
                            ?
                                coach_form.links.map((elem, index) => {
                                    return (
                                        <div className="link__wrapper" key={ index }>
                                            <div className="link">
                                                <div className="link__ico input input--tick"
                                                     style={ elem.ico ? { backgroundImage: `url(${ elem.ico })` } : {} }
                                                     onClick={ () => setSocialNetworkIcoIndex(socialNetworkIcoIndex || socialNetworkIcoIndex === 0 ? null : index) }
                                                />
                                                <div className="dropdown link__ico-dropdown">
                                                    <div className={ `dropdown__items ${ socialNetworkIcoIndex === index ? 'dropdown__items--open ' : '' }` }>
                                                        <div className="dropdown__item link__ico-item"
                                                             onClick={ () => choiceSocialNetworkLogo('', index) }
                                                        />
                                                        <div className="dropdown__item link__ico-item"
                                                             style={{ backgroundImage: `url(${ vk })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(vk, index) }
                                                        />
                                                        <div className="dropdown__item link__ico-item"
                                                             style={{ backgroundImage: `url(${ instagram })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(instagram, index) }
                                                        />
                                                        <div className="dropdown__item  link__ico-item"
                                                             style={{ backgroundImage: `url(${ youtube })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(youtube, index) }
                                                        />
                                                    </div>
                                                </div>
                                                <input type="text" className="input"
                                                       value={ elem.link }
                                                       onInput={ event => {
                                                           // Копируем массив с сылками
                                                           let links_copy = coach_form.links.map(elem => {
                                                               return { ...elem };
                                                           });
                                                           // Меняем значение в текущей ссылке
                                                           links_copy[index].link = event.target.value;

                                                           // Сохраняем новое значение
                                                           dispatch(coachFormAction({
                                                               ...coach_form,
                                                               links: links_copy
                                                           }));
                                                       } }
                                                />
                                            </div>
                                            <div className="link__remove" onClick={ () => {
                                                // Подтверждение удаления ссылки
                                                if (!window.confirm('Вы действительно хотите удалить ссылку?')) return;

                                                // Копируем массив с сылками
                                                let links_copy = coach_form.links.map(elem => {
                                                    return { ...elem };
                                                });
                                                // Удаляем выбранную ссылку
                                                links_copy.splice(index, 1);

                                                // Сохраняем новое значение
                                                dispatch(coachFormAction({
                                                    ...coach_form,
                                                    links: links_copy
                                                }));
                                            } }/>
                                        </div>
                                    );
                                })
                            : false
                        }
                        <div className="link__add" onClick={ () => {
                            // Копируем массив с сылками
                            let links_copy = coach_form.links.map(elem => {
                                return { ...elem };
                            });
                            // Добавляем новую ссылку
                            links_copy.push({ ico: '', link: '' });

                            // Сохраняем новое значение
                            dispatch(coachFormAction({
                                ...coach_form,
                                links: links_copy
                            }));
                        } }>Добавить ссылку</div>
                    </div>


                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...coach_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(coachFormAction({
                                                ...coach_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ coach_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updateCoachSagaAction({
                                    id: coach_form.id,
                                    image: photo_file || coach_form.image,
                                    name: coach_form.name,
                                    phone: coach_form.phone,
                                    email: coach_form.email,
                                    description: coach_form.description,
                                    hide: coach_form.hide,
                                    establishments: JSON.stringify(coach_form.establishments),
                                    links: JSON.stringify(coach_form.links)
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachForm;